import { isOnTheLot } from '../../../utilities/auditUtilities'

export default function AuditUnitFormData({ auditData, images, user }) {
  return new Promise((resolve) => {
    const formdata = new FormData()

    // Make sure Non Compliant Units get marked as 3C Units in DFP. This is a temporary fix until we implement the new condition system in DFP
    const condition = auditData.condition === '2' ? '3' : String(auditData.condition)

    formdata.append('audit_unit[letter]', condition)
    formdata.append('audit_unit[number]', condition)
    formdata.append('audit_unit[seen]', [1,2,3].includes(Number(condition)) ? '1' : '2')
    formdata.append('audit_unit[compliant]', String(auditData.condition) !== '3')
    formdata.append('audit_unit[audited]', '1')
    formdata.append('audit_unit[can_refloor]', auditData.can_refloor)
    formdata.append('audit_unit[notes]', auditData.notes)
    formdata.append('audit_unit[current_location]', auditData.current_location)
    if (auditData.mileage !== undefined) {
      formdata.append('audit_unit[mileage]', auditData.mileage)
    }
    if (auditData.key !== undefined) {
      formdata.append('audit_unit[key]', auditData.key)
    }
    if (auditData.run_and_drive !== undefined) {
      formdata.append('audit_unit[run_and_drive]', auditData.run_and_drive)
    }
    if (!isOnTheLot(auditData.current_location)) {
      formdata.append('audit_unit[location]', auditData.location ?? '')
    }

    if (images && typeof images === 'object') {
      Object.entries(images).forEach(([imageTitle, imageFile]) => {
        if (imageFile) {  // Only append if file exists
          formdata.append(`audit_unit[unit_files][]name`, imageTitle)
          formdata.append(`audit_unit[unit_files][]ufile`, imageFile)
          formdata.append(`audit_unit[unit_files][]photo`, '1')
          formdata.append(`audit_unit[unit_files][]created_by_id`, String(user.id))
        }
      })
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        formdata.append('audit_unit[lat]', position.coords.latitude)
        formdata.append('audit_unit[long]', position.coords.longitude)
        formdata.append('audit_unit[ipad_loc_type]', 1)
        resolve(formdata)
      }, (error) => {
        console.error('Error getting geolocation:', error)
        resolve(formdata)
      }, { timeout: 10000, maximumAge: 60000 })
    } else {
      resolve(formdata)
    }
  })
}